const productDes = {
        title: '',
        sponsor: '',
        sponsorNo: '',
        guidanceName: '',
        guidanceNo: '',
        host: '',
        contractor: '',
        type: '',
        eventPlace: '',
        amount: 100,
        eventFee: 0,
        eventRound: 4,
        eventContact: '',
        eventStartDate: '',
        eventEndDate: '',
        eventDate:  '',
        eventTime: [],
        eventStartTime: '',
        eventEndTime: '',
        eventQrcode: '',
        groupQrcode: '',
        status: '',
        imageUrl: '',
        flowImageUrl: '',
        rewardImageUrl: '',
        noticeImageUrl: '',
        ruleImageUrl: '',
        hostDimension:  1,
        entryDimension: 1,
        faceDimension: 1,
        prizeDimension: 1,
        refereeDimension: 1,
        totalGrade: 20,
        applyUrl: '',
        award: '',
        eventFlow: '',
        rules: '',
        letter:'',
        shareImage: '',//小程序赛事详情分享图片
        coverImage: '',//封面图片
        hideField: false,        
}
export default productDes


// WEBPACK FOOTER //
// ./src/config/pubObj.js